import { DocAccessType, DocumentMap, IDocumentsList } from '../../../../types';
import { Section } from '../../../Finger/Section';
import FingerWithApprove from '../../../atoms/finger-with-approve';
import NoDocuments from '../../../atoms/no-doc-placeholder';
import { getFingerStatus, getVisible, hasDeleted } from '../../../../utilities/documents';
import { UserRole } from '../../../../store/auth/types';
import { useTranslation } from "react-i18next";

interface IProps {
  infoOnly: boolean;
  userAccess?: DocAccessType;
  documents: DocumentMap;
  warning?: string;
  userRole?: UserRole;
  canUpload: boolean;
  canOpen: boolean;
  canApprove: boolean;
  canReject: boolean;
  isDeleting: boolean;
  canAcknowledge: boolean;
  onUploadClick: (docKey: string) => void;
  onOpenClick: (docKey: string) => void;
  onApproveClick: (docKey: string) => void;
  onRejectClick: (docKey: string) => void;
  onRescindRejectClick: (docKey: string) => void;
  onDeleteClick: (docKey: string) => void;
  onAcknowledgeClick: (docKey: string) => void;
}

const PostStudyLetter = (props: IProps) => {
    const { t } = useTranslation('common');
  const { documents: postStudyLetters = {}, warning, infoOnly, userAccess, userRole } = props;
  let hasDocs = false;
  let hasDeletedDocs = false;

  const visibleDocs = getVisible({
    documentsHash: postStudyLetters,
    userAccess,
    infoOnly,
    userRole,
  }) as IDocumentsList[];

  if (visibleDocs.length > 0) {
    hasDocs = true;
  }
  if (hasDeleted(postStudyLetters)) {
    hasDeletedDocs = true;
  }

  if (!hasDocs && !hasDeletedDocs) {
    return null;
  }

  if ((infoOnly || userAccess) && !hasDocs) {
    return null;
  }

  return (
    <Section
      label={t('common:weRequireYouUploadALetterOutlini')}
      warning={warning}
    >
      {visibleDocs.length > 0 ? (
        visibleDocs.map((postStudyLetter: IDocumentsList, index: number) => {
          const { key, item } = postStudyLetter;
          return (
            <FingerWithApprove
              key={`post-study-letter-${index}`}
              status={getFingerStatus(item)}
              isProcessingPdf={item.isProcessingPdf}
              reason={item.reason}
              fileCount={item.signedUrls && item.signedUrls.length > 0 ? item.signedUrls.length : 0}
              fileNames={item.fileNames}
              label={t('common:personalPostStudyLetter', { index: Object.keys(postStudyLetters).length > 1 ? (index > 0 ? index + 1 : '') : '' })}
              canUpload={infoOnly ? false : props.canUpload}
              canOpen={infoOnly ? false : props.canOpen}
              canApprove={infoOnly ? false : props.canApprove}
              canReject={infoOnly ? false : props.canReject}
              isDeleting={infoOnly ? false : props.isDeleting}
              canAcknowledge={infoOnly ? props.canAcknowledge : false}
              onUploadClick={() => props.onUploadClick(key)}
              onOpenClick={() => props.onOpenClick(key)}
              onApproveClick={() => props.onApproveClick(key)}
              onRejectClick={() => props.onRejectClick(key)}
              onRescindRejectClick={() => props.onRescindRejectClick(key)}
              onDeleteClick={() => props.onDeleteClick(key)}
              onAcknowledgeClick={() => props.onAcknowledgeClick(key)}
              userRole={props.userRole}
              deletedByTTL={item.deletedByTTL}
            />
          );
        })
      ) : (
        <NoDocuments />
      )}
    </Section>
  );
};

export default PostStudyLetter;
